import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Import the PC view components
import PCView from './PCView';
import PCProfessionalView from './PCProfessionalView';
import PCMiscView from './PCMiscView';

// Import dedicated experience and projects pages
import ExperienceDetailPage from './Professional/Experience/DetailPage';
import ResearchDetailPage from './Professional/Research/DetailPage';
import ActivitiesDetailPage from './Professional/Activities/DetailPage';
import AccoladesDetailPage from './Misc/Accolades/DetailPage';
import ProjectsDetailPage from './Misc/Projects/DetailPage';
import BlogDetailPage from './Misc/Blog/DetailPage';

const PCRouter = ({ isDarkMode, toggleTheme }) => {
    return (
        <Routes>
            <Route path="/" element={<PCView isDarkMode={isDarkMode} toggleTheme={toggleTheme} />} />
            <Route path="/prof" element={<PCProfessionalView isDarkMode={isDarkMode} toggleTheme={toggleTheme} />} />
            <Route path="/misc" element={<PCMiscView isDarkMode={isDarkMode} toggleTheme={toggleTheme} />} />
            <Route path="/experience" element={<ExperienceDetailPage isDarkMode={isDarkMode} toggleTheme={toggleTheme} />} />
            <Route path="/projects" element={<ProjectsDetailPage isDarkMode={isDarkMode} toggleTheme={toggleTheme} />} />
            <Route path="/research" element={<ResearchDetailPage isDarkMode={isDarkMode} toggleTheme={toggleTheme} />} />
            <Route path="/accolades" element={<AccoladesDetailPage isDarkMode={isDarkMode} toggleTheme={toggleTheme} />} />
            <Route path="/blogs" element={<BlogDetailPage isDarkMode={isDarkMode} toggleTheme={toggleTheme} />} />
            <Route path="/activities" element={<ActivitiesDetailPage isDarkMode={isDarkMode} toggleTheme={toggleTheme} />} />
        </Routes>
    );
};

export default PCRouter;